export default __webpack_public_path__ + "static/media/text-icon.adfe806d.svg";